import React, { useState } from "react";
import cn from "clsx";
import ReactHtmlParser from "react-html-parser";
import DeliveryDropdown from "./deliveryDropdown";

import expressDeliverySrc from "@/images/express_delivery.svg";

import "./style.scss";
import { useTranslation } from "react-i18next";

const DeliveryTimelineDropdown = ({
  deliveryTimelines,
  selectedDeliveryTimeline,
  isCart,
  onDeliveryChange
}: {
  deliveryTimelines: any;
  selectedDeliveryTimeline: any;
  isCart?: boolean;
  onDeliveryChange?: (timeline: any) => Promise<void>;
}) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const { t } = useTranslation("myCart");

  const invalidSingleTimeline =
    deliveryTimelines.length === 1 && deliveryTimelines[0].stateId < 0;

  const showDropdown = !invalidSingleTimeline;

  return (
    <div
      className={cn("delivery_timeline_wrapper", {
        on_cart: isCart
      })}
    >
      {selectedDeliveryTimeline && (
        <div className="selected_delivery_message_wrapper">
          {isCart ? (
            <p className="based_on">{t("basedOn")}</p>
          ) : (
            <img src={expressDeliverySrc} alt="express_delivery" height={22} />
          )}
          <span className="selected_delivery_message">
            {ReactHtmlParser(selectedDeliveryTimeline.title)}
          </span>
        </div>
      )}
      {showDropdown && (
        <div className="delivery_dropdown_container">
          <div
            className={cn("selected_timeline", {
              dropdown_opened: openDropdown
            })}
            onClick={e => {
              e.stopPropagation();
              setOpenDropdown(prev => !prev);
            }}
          >
            <span>{selectedDeliveryTimeline?.stateName}</span>
          </div>

          <DeliveryDropdown
            isOpen={openDropdown}
            onClose={() => setOpenDropdown(false)}
            data={deliveryTimelines}
            onOptionClick={onDeliveryChange}
            selectedOption={selectedDeliveryTimeline}
          />
        </div>
      )}
    </div>
  );
};

export default DeliveryTimelineDropdown;
